export default __webpack_public_path__ + "static/media/three-dots-gray.4685bdd8.svg";